module.exports = __webpack_public_path__ + "img/b19.201f90b4.jpg";